import useForm, {
  UseFormEvent,
} from "../../../../../custom-hooks/form/useForm";
import useFormWarning from "../../../../../custom-hooks/form/useFormWarning";
import useInputChangeHandler from "../../../../../custom-hooks/form/handlers/useInputChangeHandler";
import useCheckboxChangeHandler from "../../../../../custom-hooks/form/handlers/useCheckboxChangeHandler";
import useSelectChangeHandler from "../../../../../custom-hooks/form/handlers/useSelectChangeHandler";
import { Subnet } from "../types/subnet";
import { PredefinedParams } from "../../../../../components/slidingpanel/type";
import { NetworkForm } from "../types/formData";
import { useCallback } from "react";

type UseNetworkCreateFormProps = {
  nameRef: React.RefObject<HTMLElement>;
  regionRef: React.RefObject<HTMLElement>;
  subnetRefs: React.RefObject<HTMLDivElement>[];
  setSubnetRefs: React.Dispatch<
    React.SetStateAction<React.RefObject<HTMLDivElement>[]>
  >;
  predefined_params?: PredefinedParams;
};

const useNetworkCreateForm = ({
  nameRef,
  regionRef,
  subnetRefs,
  setSubnetRefs,
  predefined_params,
}: UseNetworkCreateFormProps) => {
  const { formWarning, showFormWarning, hideFormWarning } = useFormWarning();

  const { formData, error, handleChange } = useForm({
    validations: [
      {
        field: "name",
        requiredMessage: "Please enter a name for your network.",
        ref: nameRef,
      },
      {
        field: "region",
        requiredMessage: "Please select a region.",
        ref: regionRef,
      },
    ],
    initialState: {
      portSecurity: true,
      gatewayStatus: true,
      enableDhcp: true,
    },
  }) as {
    formData: NetworkForm;
    error: any;
    handleChange: (event: UseFormEvent | Array<UseFormEvent>) => void;
  };

  const handleSubnetsChange = useCallback(
    (subnets: Subnet[]) => {
      handleChange({ name: "subnets", value: subnets });
      hideFormWarning();
    },
    [handleChange, hideFormWarning],
  );

  const handleInputChange = useInputChangeHandler({
    handleChange,
    hideFormWarning,
  });
  const handleCheckboxChange = useCheckboxChangeHandler({
    handleChange,
    hideFormWarning,
  });
  const handleSelectChange = useSelectChangeHandler({
    handleChange,
    hideFormWarning,
  });

  return {
    formWarning,
    showFormWarning,
    error,
    formData,
    handleInputChange,
    handleSelectChange,
    handleCheckboxChange,
    handleSubnetsChange,
    nameRef,
    regionRef,
    subnetRefs,
    setSubnetRefs,
    predefined_params,
  };
};

export default useNetworkCreateForm;
